import { SOPTemplateAPI, Template } from "./types";

export const transformSOPTemplate = (apiTemplate: SOPTemplateAPI): Template => {
  // Calculate SLA progress

  return {
    id: apiTemplate.id.toString(),
    name: apiTemplate.name,
    association: apiTemplate.sopAssociationTypeDisplay,
    type: apiTemplate.sopTypeDisplay ?? "NA",
    subtype: apiTemplate.sopSubtypeDisplay ?? "NA",
    sopType: apiTemplate.sopType ?? "NA",
    sopSubtype: apiTemplate.sopSubtype ?? "NA",
    description: apiTemplate.description,
    status: apiTemplate.statusDisplay.toLowerCase(), // ✅ updated
    isActive: apiTemplate.isActive,
    version: apiTemplate.version.replace("Version-", ""),
    createdAt: apiTemplate.createdDate, // ✅ updated
    createdBy: apiTemplate.createdUserRemoteName, // ✅ updated
    taskCount: apiTemplate.taskCount,
    usageCount: apiTemplate.usageCount,
    totalCost: apiTemplate?.materialCostCount?.toString() || "NA", // ✅ updated
    estTotalCost: apiTemplate?.estTotalCost?.toString(),

    sla: {
      value: apiTemplate?.rulesDuration?.toString() || "NA", // ✅ updated
      progress: apiTemplate?.usageCount,
    },
    serviceNo: apiTemplate?.serviceNo?.toString(),
  };
};

// Filter and search utilities
export const applyClientSideFilters = (
  templates: Template[],
  searchTerm: string,
  filters?: {
    association?: string;
    type?: string;
    status?: string;
  },
): Template[] => {
  let filtered = [...templates];

  // Apply search filter
  if (searchTerm) {
    const searchLower = searchTerm.toLowerCase();
    filtered = filtered.filter(
      (template) =>
        template.name.toLowerCase().includes(searchLower) ||
        template.description.toLowerCase().includes(searchLower) ||
        template.id.includes(searchTerm) ||
        template.association.toLowerCase().includes(searchLower) ||
        template.type.toLowerCase().includes(searchLower),
    );
  }

  // Apply additional filters
  if (filters) {
    if (filters.association) {
      filtered = filtered.filter((t) => t.association === filters.association);
    }
    if (filters.type) {
      filtered = filtered.filter((t) => t.type === filters.type);
    }
    if (filters.status) {
      filtered = filtered.filter((t) => t.status === filters.status);
    }
  }

  return filtered;
};
